import { BodyText } from "@/components/ui/Text";
import { Practitioner } from "@curai/js-fhir-tools";
import { formatDate } from "date-fns";
import type { ChatMessage } from "../../types/chatMessageTypes";

interface ProviderBioMessageProps {
  message: ChatMessage;
}

export const ProviderBioMessage = ({ message }: ProviderBioMessageProps) => {
  const practitioner = new Practitioner(message.fhirPractitioner as object);
  return (
    <div className="flex flex-col gap-1 justify-center items-center">
      <BodyText size="sm" textColor="primary" italic>
        {practitioner.chatTitle} has joined the chat.
      </BodyText>
      <BodyText size="xs" textColor={"tertiary"}>
        {formatDate(new Date(message.created), "MM/dd/yyyy h:mm a")}
      </BodyText>
    </div>
  );
};
